export const CameraStatus = {
  /**@type {string} */
  TESTING: "testing",
  /**@type {string} */
  CONNECTED: "connected",
  /**@type {string} */
  DISCONNECTED: "disconnected",
  /**@type {string} */
  IN_CONFIGURATION: "in_configuration",
  /**@type {string} */
  CONFIGURED: "configured",
  /**@type {string} */
  CONNECTED_IN_GROUP: "connected_in_group",
};
